'use strict';

var React              = require('react'),
    ApplicationActions = require('js/shared/actions/application-actions.js'),
    Textarea           = require('react-textarea-autosize'),
    classnames         = require('classnames');

var KEY_ENTER = "Enter";

var TextAreaInput = React.createClass({

  propTypes: {
    // type: React.PropTypes.number.isRequired,
    title: React.PropTypes.string.isRequired,
    fieldName: React.PropTypes.string.isRequired,
    subtitle: React.PropTypes.string,

    // list types
    // list: React.PropTypes.arrayOf(React.PropTypes.string),

    // anything that can continue via. a trigger, like hitting Enter
    nextCallback: React.PropTypes.func,

    // existing value state
    value: React.PropTypes.string,
    autoFocus: React.PropTypes.bool,
    onReview: React.PropTypes.bool,
    hasError: React.PropTypes.bool
  },

  getDefaultProps: function() {
    return {
      value: "",
      autoFocus: false,
      onReview: false
    };
  },

  getInitialState: function() {
    return {
      value: this.props.value,
      showError: false
    };
  },

  _handleChange: function(evt) {
    var newValue = evt.target.value;

    this.setState({
      value: newValue
    });
    ApplicationActions.updateField(this.props.fieldName, newValue);

    if(!this.state.showError) {
      this.setState({
        showError: true
      });
    }
  },

  render: function() {
    var titleClasses = classnames({
      'QuestionInput-title': true,
      'QuestionInput-title--compact': true,
      'QuestionInput-title--placeholderSmall': this.state.value === "" && !this.props.onReview,
      'QuestionInput-title--review': this.props.onReview
    });

    var inputClasses = classnames({
      'QuestionInput-textAreaField': true,
      'QuestionInput-textAreaField--review': this.props.onReview
    });

    var error = null;
    if(this.state.showError && this.props.hasError) {
      error = (
        <div className="QuestionError">
          This field cannot be blank.
        </div>
      );
    }

    return (
      <div>
        <div
          className={titleClasses}>
          {this.props.title}
        </div>
        <Textarea
          className={inputClasses}
          value={this.state.value}
          onChange={this._handleChange}
          autoFocus={this.props.autoFocus}
          minRows="5"/>
        {error}
      </div>
    );
  }
});

module.exports = TextAreaInput;



/** WEBPACK FOOTER **
 ** ./js/screens/form/input/textarea.jsx
 **/